var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',{attrs:{"value":_vm.value,"items":_vm.items,"item-text":"title","item-value":"category_view_id","required":_vm.required,"dense":"","filled":"","label":"Görünüm seç"},on:{"input":_vm.updateValue}})}
var staticRenderFns = []

export { render, staticRenderFns }